import AiTrainingAdd from './AiTrainingAdd';

export default AiTrainingAdd;
